import { Controller } from "@hotwired/stimulus";
import QRCode from "qrcode";

// Connects to data-controller="qrcode"
export default class extends Controller {
  static targets = ["qrcode"];

  connect() {
    this.generateQRCode();
  }

  generateQRCode() {
    QRCode.toDataURL(this.qrcodeTarget.dataset.text, { margin: 4, width: this.qrcodeTarget.dataset.width }).then(
      (url) => {
        this.qrcodeTarget.src = url;
        this.qrcodeTarget.href = url;
      },
    );
  }
}
